import { useState, type FormEvent } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthProvider';

export function LoginPage() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [loginValue, setLoginValue] = useState('');
  const [password, setPassword] = useState('');
  const [pending, setPending] = useState(false);
  const [error, setError] = useState('');

  if (user) return <Navigate replace to="/dashboard/active" />;

  const submit = async (event: FormEvent) => {
    event.preventDefault();
    setPending(true);
    setError('');
    try {
      await login(loginValue, password);
      const requested = (location.state as { from?: string } | null)?.from;
      void navigate(requested || '/dashboard/active', { replace: true });
    } catch (reason) {
      setError(reason instanceof Error ? reason.message : 'Не удалось войти');
    } finally {
      setPending(false);
    }
  };

  return (
    <form className="login-form" onSubmit={(event) => void submit(event)}>
      <input
        aria-label="Логин"
        autoComplete="username"
        autoFocus
        onChange={(event) => setLoginValue(event.target.value)}
        placeholder="Логин"
        required
        value={loginValue}
      />
      <input
        aria-label="Пароль"
        autoComplete="current-password"
        onChange={(event) => setPassword(event.target.value)}
        placeholder="Пароль"
        required
        type="password"
        value={password}
      />
      <button className="button" disabled={pending} type="submit">{pending ? 'Вход…' : 'Войти'}</button>
      {error ? <p className="form-error">{error}</p> : null}
    </form>
  );
}
